import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CircleIconButtonComponent } from '@iss/core/circle-icon-button';

@Component({
  selector: 'wo-remove-circle-icon-button',
  templateUrl: './remove-circle-icon-button.component.html',
  styleUrls: [ './remove-circle-icon-button.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CircleIconButtonComponent,
  ],
})
export class RemoveCircleIconButtonComponent {
  @Input() public size: 'large' | 'small' = 'large';
  @Input() public tooltip?: string;
}
